import { Aspect } from '@teambit/harmony';

export const ExportAspect = Aspect.create({
  id: 'teambit.scope/export',
});
